import React, { useState } from "react";
import { Alert, Button, Card } from "../components";
import { TextTitleStyle, TitleStyle } from "../components/styles/TitleStyle";
import { BulkPaymentEntrySelectionStyle, BulkPaymentEntryStyle, BulkPaymentEntryTitleSectionStyle } from "../components/styles/FilterStyle";
import {  SecondaryButtonStyle } from "../components/styles/ButtonStyle";
import Title from "../components/text/Title";
import FileUpload from "../components/input/FileUpload";
import { BulkPaymentFileUploadStyle } from "../components/styles/InputStyle";
import { AlertVariant } from "../types-interfaces/types";
import { massivePaymentUploadFile } from "../services/api-ssrr/CollectionManagerAPIClient";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { MassivePaymentUpload, UserState } from "../types-interfaces/interfaces";
import { Buffer } from "buffer";
import { SummaryAmountStyle, SummaryTableStyle } from "../components/styles/SummaryStyle";
import { getNumberWithThousandsSeparator, moneyFormat } from "../functions/Format";
import languageEncoding from "detect-file-encoding-and-language";
import RadioButtonGroup from "../components/input/RadioButtonGroup";
import { EntidadRecaudadora } from "../enums-lists/EntidadRecaudadora";

interface AlertState {  
  text: string | undefined
  alertVariant: AlertVariant
}

const BulkPaymentFileHeader:Array<string> = [
  "CustomerId",
  "PayerId",
  "Amount",
  "CurrencyType",
  "PaymentType",
  "PaymentCreationDate",
  "AccrualDate",
  "DepositBank",
  "IdAbono"
]

function IngresoPagoMasivo () {
  const [alert, setAlert] = useState<AlertState>({text: undefined, alertVariant: undefined});
  const [massivePaymentUpload, setMassivePaymentUpload] = useState<MassivePaymentUpload>({});
  const [company, setCompany] = useState(EntidadRecaudadora.find(e => e.name === "Principal AGF")?.value ?? 0);
  const [isError, setIsError] = useState(false);  
  const userState = useSelector<RootState, UserState>((state) => state.userState);

  async function handleBulkPayment() {
    
    if (isError ||
      !massivePaymentUpload.file ||
      !massivePaymentUpload.encoding ||
      !massivePaymentUpload.fileName ||
      !massivePaymentUpload.mimeType ||
      !massivePaymentUpload.rowsNumber ||
      !massivePaymentUpload.size ||
      (!massivePaymentUpload.totalAmountCLP && !massivePaymentUpload.totalAmountUSD) ||
      !company ||
      company < 1
    ){      
      return;
    }
    
    let response = await massivePaymentUploadFile(massivePaymentUpload, userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
    let success = response && response.idProcess && response.status;
    let newText = success ?
      "Archivo cargado correctamente. Id Proceso: " + response.idProcess :
      "No se ha podido ingresar el pago masivo correctamente. " + response.details?.join('\n') ?? " Verifique que el archivo no este dañado o intente más tarde.";
    let newAlertVariant:AlertVariant = success ? "success" : "error" ;

    setAlert({
      text: newText,
      alertVariant: newAlertVariant,      
    })

    if (success){
      handleUploadFile(undefined);
    }
  }

  async function handleUploadFile(file: File | undefined){    
    
    if (file === undefined){      
      setMassivePaymentUpload({});
      return;
    }

    let encoding = (await languageEncoding(file).then((fileInfo) => {return fileInfo})).encoding?.toString();

    let str = await file.text();
    let stringB64 = Buffer.from(str, 'binary').toString('base64');    

    let newRowsNumber = 0;
    let newTotalAmountCLP = 0;
    let newTotalAmountUSD = 0;
    let indexCurrency = BulkPaymentFileHeader.indexOf("CurrencyType");
    let indexAmount = BulkPaymentFileHeader.indexOf("Amount");

    let fileArray = (await file.text()).split('\n')?? [];
    
    fileArray.forEach(row => {
      let rowArray = row.replaceAll("\r","").split(",");
      
      if (rowArray.toString() !== BulkPaymentFileHeader.toString() && rowArray.toString().length > 0) {
        newRowsNumber++;

        let amount = parseFloat(rowArray[indexAmount] ?? "0") ?? 0;

        if (rowArray[indexCurrency] === "CLP")
          newTotalAmountCLP += amount;
        
        if (rowArray[indexCurrency] === "USD")
          newTotalAmountUSD += amount;
      }
    })

    if (isError){
      return;
    }

    setMassivePaymentUpload({
      file: stringB64,
      fileName: file.name,
      size: file.size,
      rowsNumber: newRowsNumber,
      totalAmountCLP: newTotalAmountCLP,
      totalAmountUSD: newTotalAmountUSD,
      mimeType: file.type,
      encoding: encoding,
      company: company,
      email: userState.currentSession?.user?.email!
    })
  }

  return(
    <div style={BulkPaymentEntryStyle}>
      <div style={BulkPaymentEntryTitleSectionStyle}>
        <Title
          text="Ingreso pago masivo"
          style={TitleStyle}
        />
        <Title
          text="A continuación completa el formulario con la información correspondiente del pago a guardar."
          style={TextTitleStyle}
        />
        {alert.text &&
          <Alert              
            text={alert.text}
            type={alert.alertVariant}
            onClose={() => setAlert({ text:"", alertVariant:undefined })}
          />
        }
      </div>
      <div style={BulkPaymentEntrySelectionStyle}>
        <RadioButtonGroup
          label="Selecciona una entidad recaudadora"
          values={EntidadRecaudadora.filter((val) => val.value > 0)}
          onChange={(e) => setCompany(parseInt(e.currentTarget.value))}
          defaultChecked={true}
          defaultValue={EntidadRecaudadora.find(e => e.name === "Principal AGF")?.value}
          style={{display:"none"}}
        />
        <FileUpload
          style={BulkPaymentFileUploadStyle}
          label="Adjuntar archivo"
          text="Sube tu archivo en formato CSV aquí, Solo se permite un archivo por ingreso."
          type="csv"
          encoding="utf-8"
          validHeader={BulkPaymentFileHeader}
          required
          maximumFiles={1}
          uploadedFile={handleUploadFile}
          isError={(error) => setIsError(error)}/>
      </div>
      <div
        style={{alignSelf:"flex-start"}}
      >
        <Card style={{
          ...SummaryTableStyle,
          margin:"0px"
          }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "24px",              
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos a ingresar: {getNumberWithThousandsSeparator(massivePaymentUpload.rowsNumber ?? 0)}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Total pagos en CLP: {moneyFormat(massivePaymentUpload.totalAmountCLP??0,"CLP")}
            </span>              
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
              <span style={SummaryAmountStyle}>
              Total pagos en USD: {moneyFormat((massivePaymentUpload.totalAmountUSD??0).toFixed(2),"USD")}
            </span>              
          </div>
        </div>
        <Button
          text="Ingresar pago masivo"
          style={SecondaryButtonStyle}
          onClick={handleBulkPayment}
        />        
      </Card>
        
      </div>
    </div>
  )  
  
}

export default IngresoPagoMasivo;